export default __webpack_public_path__ + "static/media/floral_02.696dd010.png";